import axios from "axios";

import { SERVICE_URL, STATUS_CODE  } from "./Constants";

export const CALL_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS || status === true) return response;
    throw new Error(`API call failed: ${action}`);
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};
